import React from 'react'

function OperationsHomePage() {
  return (
    <div>OperationsHomePage</div>
  )
}

export default OperationsHomePage